var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSentimentNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44604 14H19.3379V15.5H6.44604V14Z",
    fill: "#605DEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17L9 12.5L10.5 12.5L10.5 17L9 17Z",
    fill: "#605DEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 17L12.5 12.5L14 12.5L14 17L12.5 17Z",
    fill: "#605DEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17L16 12.5L17.5 12.5L17.5 17L16 17Z",
    fill: "#605DEC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.652 11C17.542 11 18.2635 10.3284 18.2635 9.5C18.2635 8.67157 17.542 8 16.652 8C15.762 8 15.0405 8.67157 15.0405 9.5C15.0405 10.3284 15.762 11 16.652 11Z",
    fill: "#605DEC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13175 11C10.0217 11 10.7432 10.3284 10.7432 9.5C10.7432 8.67157 10.0217 8 9.13175 8C8.24175 8 7.52026 8.67157 7.52026 9.5C7.52026 10.3284 8.24175 11 9.13175 11Z",
    fill: "#605DEC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8811 2C18.8221 2 23.635 6.48 23.635 12C23.635 17.52 18.8221 22 12.8811 22C6.95087 22 2.14868 17.52 2.14868 12C2.14868 6.48002 6.95087 2.00004 12.8811 2ZM12.8918 4C8.14337 4.00004 4.29712 7.58002 4.29712 12C4.29712 16.42 8.14337 20 12.8918 20C17.6404 20 21.4866 16.42 21.4866 12C21.4866 7.58 17.6404 4 12.8918 4Z",
    fill: "#605DEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSentimentNeutral);
export default __webpack_public_path__ + "static/media/sentiment_neutral.9a344d23560020c0f16c3d6f0f99239c.svg";
export { ForwardRef as ReactComponent };